var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"border-variant":_vm.borderVariant,"header":_vm.header,"header-bg-variant":_vm.headerColor,"header-text-variant":_vm.headerTextVariant,"align":"left"}},[_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }